import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useIncotermService from '../../../app/services/hooks/useIncotermService';

interface Props {
    incotermId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const IncotermSwitchChange = ({ incotermId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);
    const { activeIncoterm, fetchingActiveIncoterm } = useIncotermService();

    const active = (value: boolean) => {
        setChecked(value);
        activeIncoterm(incotermId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={incotermId} callback={active} />;
};

export default IncotermSwitchChange;
